











































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
/* api */
import stageUpdateApi from '@/app/model/api/stageUpdateApi'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    Error409Modal,
    ErrorInfo
  }
})
export default class StageUpdateModal extends Vue {
  private stageData: {[key: string]: number|string|any} = {}
  private variableDay: string = ''
  private defaultDay: string = ''
  private changeId: number = 0
  private showError409Modal: boolean = false
  private errorMessage: string = ''
  private showStageUpdateDetail: boolean = false
  private show400ErrorMessage: boolean = false
  private alertText: string = ''
  private alertTitle: string = ''

  /* computed */
  private get stageUpdateId (): number {
    return this.$store.state.stageUpdateState.changeStageId
  }

  @Watch('stageUpdateId')
  onChangeId (val: any) {
    this.changeId = val
    let growthList = JSON.parse(Session.getGrowthStage()!)

    for (var i in growthList) {
      if (growthList[i].growth_stage_id === val) {
        this.defaultDay = this.getDate(growthList[i].elapsed_days)
        this.variableDay = this.getDate(growthList[i].elapsed_days)
        this.stageData = growthList[i]

        // 更新履歴表示切替
        if (this.stageData.growth_stage_histories.length !== 0) {
          this.showStageUpdateDetail = true
        } else {
          this.showStageUpdateDetail = false
        }
      }
    }
  }

  private getDate (days: number) {
    let plantingDay = parseInt(Session.getPlantingDay()!)
    let newDay = new Date(DateClass.formingDate(plantingDay).getTime() + days * 24 * 60 * 60 * 1000)
    return newDay.getFullYear() + '-' + DateClass.toDoubleDigits(newDay.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDay.getDate())
  }

  private setNewData () {
    let growthList = JSON.parse(Session.getGrowthStage()!)
    let current:any = {}
    let previous:any = {}
    let after:any = {}

    /* 前後のステージを取得 */
    for (var i in growthList) {
      if (growthList[i].growth_stage_id === this.changeId) {
        current = growthList[i]
      }

      if (growthList[i].growth_stage_id === this.changeId + 1) {
        after = growthList[i]
      }

      if (growthList[i].growth_stage_id === this.changeId - 1) {
        previous = growthList[i]
      }
    }

    let diff = (new Date(this.variableDay).getTime() - new Date(this.defaultDay).getTime()) / (1000 * 60 * 60 * 24)

    let errorFlag: boolean = false

    /* ステージの範囲内で日付を変更 */
    if ((current.elapsed_days + diff) <= previous.elapsed_days) {
      this.errorMessage = previous.growth_stage_name + '以前の日程は入力できません。'
    } else if ((current.elapsed_days + diff) <= previous.elapsed_days && Object.keys(previous).length === 0) {
      this.errorMessage = previous.growth_stage_name + '以前の日程は入力できません。'
    } else if ((current.elapsed_days + diff) >= after.elapsed_days) {
      this.errorMessage = after.growth_stage_name + '以降の日程は入力できません。'
    } else if ((current.elapsed_days + diff) >= after.elapsed_days && Object.keys(after).length === 0) {
      this.errorMessage = after.growth_stage_name + '以降の日程は入力できません。'
    } else {
      errorFlag = true
      this.errorMessage = ''
      this.upDateStageData(diff)
    }

    if (!errorFlag) {
      this.alertText = ''
      this.show400ErrorMessage = true
    }
  }

  private closeModal () {
    this.errorMessage = ''
    this.variableDay = this.defaultDay
    this.show400ErrorMessage = false
    this.$emit('close-modal')
  }

  private async upDateStageData (diff: number) {
    let date = this.defaultDay.slice(0, 4) + this.defaultDay.slice(5, 7) + this.defaultDay.slice(8, 10)
    let growthList = JSON.parse(Session.getGrowthStage()!)
    let plantingId = parseInt(Session.getPlantingId()!)

    const bodyData = {
      'planting_id': plantingId,
      'stage_id': this.stageData.growth_stage_id,
      'date': date,
      'diff': diff,
      'time_stamp': this.stageData.time_stamp
    }

    const result = await stageUpdateApi.updateStage(bodyData)

    if (result.isOk()) {
      diff = 0
      this.$emit('reacquire-stage')
      this.$emit('close-modal')
      this.defaultDay = this.variableDay
      this.show400ErrorMessage = false
    } else if (result.getPayload().status_code === '400') {
      let errors: any = []
      errors.push('<ul>')
      for (var j in result.getPayload().errors) {
        if (result.getPayload().errors[j].code === '20604WR001' ||
            result.getPayload().errors[j].code === '20604WR002' ||
            result.getPayload().errors[j].code === '20604WR003') {
          errors.push('<li>' + result.getPayload().errors[j].message + '</li>')
        }
      }
      errors.push('</ul>')

      if (errors.length === 0) {
        this.alertText = ''
        this.alertTitle = '生育ステージの更新に失敗しました。'
      } else {
        this.alertText = errors.join('')
        this.alertTitle = ''
      }
      this.show400ErrorMessage = true
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'alert')
      const bodyElement = document.querySelector('body')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
        bodyElement!.style.overflowY = 'hidden'
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private dateToStringYmdHm (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate()) + ' ' + DateClass.toDoubleDigits(updateDate.getHours()) + ':' + DateClass.toDoubleDigits(updateDate.getMinutes())
      return formingDate
    }
  }

  private dateToStringYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate())
      return formingDate
    }
  }

  private nextDate () {
    let newDate = new Date(new Date(this.variableDay).getTime() + 1 * 24 * 60 * 60 * 1000)
    this.variableDay = newDate.getFullYear() + '-' + DateClass.toDoubleDigits(newDate.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDate.getDate())
  }

  private prevDate () {
    let newDate = new Date(new Date(this.variableDay).getTime() - 1 * 24 * 60 * 60 * 1000)
    this.variableDay = newDate.getFullYear() + '-' + DateClass.toDoubleDigits(newDate.getMonth() + 1) + '-' + DateClass.toDoubleDigits(newDate.getDate())
  }
}
